// HandoverChecklistArticle.tsx
import { Col, Row } from "react-bootstrap";
import MaterialIcon from "../../material-icon";
import { colorPalette } from "../../../utils/theme";
import useIsMobile from "../../../hooks/useIsMobile";
import { ArticleImage, ArticleTitle, ArticleSubtitle, SharingContainer, ArticleDescription, Headline, ThreeDots, ArticleText, FilterContainer, AuthorName, SubHeadline, ArticleImageContainer, BulletPointList, BulletPointItem } from "../article.styles";
import HandoverChecklistImage from "../../../assets/images/articles/handover-checklist-large.webp";
import HandoverChecklistMobileImage from "../../../assets/images/articles/handover-checklist.webp";
import Filter from "../../filter/filter";
import { useCallback, useState } from "react";
import { useTranslation } from 'react-i18next';

interface HandoverChecklistArticleProps {
    onClickShare: () => void;
}

const HandoverChecklistArticle: React.FC<HandoverChecklistArticleProps> = ({ onClickShare }) => {
    const isMobile = useIsMobile();
    const { t } = useTranslation();

    const renderHeaderContent = useCallback(() => {
        return (
            <ArticleImageContainer>
                <ArticleImage
                    src={isMobile ? HandoverChecklistMobileImage : HandoverChecklistImage}
                    alt="Article Thumbnail"
                    showBorderRadius={!isMobile}
                />
            </ArticleImageContainer>
        );
    }, []);

    return (
        <>
            {isMobile && (
                renderHeaderContent()
            )}

            <Row className="justify-content-center flex-grow-1" style={{ paddingLeft: 16, paddingRight: 16 }}>
                <Col xs={12} lg={8}>
                    <ArticleTitle>{t("articles.handover_checklist.title")}</ArticleTitle>
                    <ArticleSubtitle>{t("articles.handover_checklist.subtitle")}</ArticleSubtitle>

                    <SharingContainer>
                        <AuthorName>Managd Knowledge Hub</AuthorName>
                        <MaterialIcon icon="share" size={24} color={colorPalette.textDark} onClick={onClickShare} />
                    </SharingContainer>

                    {!isMobile && (
                        renderHeaderContent()
                    )}

                    <ArticleDescription>{t("articles.handover_checklist.intro")}</ArticleDescription>

                    <ThreeDots />

                    <Headline>{t("articles.handover_checklist.process_title")}</Headline>
                    <ArticleText>{t("articles.handover_checklist.process_intro")}</ArticleText>

                    <SubHeadline>{t("articles.handover_checklist.section1_title")}</SubHeadline>
                    <ArticleText>{t("articles.handover_checklist.section1_text")}</ArticleText>

                    <SubHeadline>{t("articles.handover_checklist.section2_title")}</SubHeadline>
                    <ArticleText>{t("articles.handover_checklist.section2_text")}</ArticleText>

                    <SubHeadline>{t("articles.handover_checklist.section3_title")}</SubHeadline>
                    <ArticleText>{t("articles.handover_checklist.section3_text")}</ArticleText>


                    <SubHeadline>{t("articles.handover_checklist.section4_title")}</SubHeadline>
                    <ArticleText>{t("articles.handover_checklist.section4_text")}</ArticleText>

                    <ThreeDots />

                    <Headline>{t("articles.handover_checklist.why_managd_title")}</Headline>
                    <ArticleText>{t("articles.handover_checklist.why_managd_text")}</ArticleText>
                    <BulletPointList>
                        <BulletPointItem>{t("articles.handover_checklist.benefit1")}</BulletPointItem>
                        <BulletPointItem>{t("articles.handover_checklist.benefit2")}</BulletPointItem>
                        <BulletPointItem>{t("articles.handover_checklist.benefit3")}</BulletPointItem>
                        <BulletPointItem>{t("articles.handover_checklist.benefit4")}</BulletPointItem>
                    </BulletPointList>

                    <ThreeDots />

                    <Headline>{t("articles.handover_checklist.conclusion_title")}</Headline>
                    <ArticleText>{t("articles.handover_checklist.conclusion_text")}</ArticleText>

                    {/*<FilterContainer>
                        <Filter label="Handover" disabled />
                        <Filter label="Mietverwaltung" disabled />
                        <Filter label="Services" disabled />
                    </FilterContainer>*/}
                </Col>
            </Row>
        </>
    );
};

export default HandoverChecklistArticle;
